import { returnPath } from "~/features/common/utils/navigation/returnPath";

export const getIndexPath = returnPath("/protocol/dashboard");

export const getIndexaaaPath = returnPath("/protocol/dashboard/indexaaa");
